/**
 * @copyright Copyright 2015-2016 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "mw-form/RadioButton",
    "MW/toolstrip/mixins/property/MnemonicMixin",
    "MW/toolstrip/mixins/property/MnemonicKeyNavDirectionMixin",
    "MW/toolstrip/mixins/property/TypeMixin",
    "MW/toolstrip/mixins/property/DescriptionOverrideMixin",
    "MW/toolstrip/mixins/property/TextMixin",
    "MW/toolstrip/mixins/property/TextOverrideMixin",
    "mw-form/mixins/property/ShortcutMixin",
    "MW/toolstrip/mixins/property/ButtonGroupMixin",
    "mw-form/mixins/mixinDependencyValidator"

], function (declare, RadioButton, MnemonicMixin, MnemonicKeyNavDirectionMixin, TypeMixin, DescriptionOverrideMixin,
             TextMixin, TextOverrideMixin, ShortcutMixin, ButtonGroupMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([RadioButton, MnemonicMixin, MnemonicKeyNavDirectionMixin,
            TypeMixin, DescriptionOverrideMixin, TextMixin, TextOverrideMixin, ShortcutMixin, ButtonGroupMixin]),
        {
            visualFamily: "default",
            height: 22,

            _qeSetChecked: function(check) {
                this.set("checked", check, true);
            }
        });

});
